import React, { useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CarouselContainer, CarouselSlide, Image } from './styles';
import { ArquivosExternosContext } from '../../context/ArquivosExternosContext';

function Carousel() {
	const { user } = useSelector((state) => state.auth);
	const { getBanners, bannersLista } = useContext(ArquivosExternosContext);

	const [currentSlide, setCurrentSlide] = useState(0);
	const tipoPerfil = ['Todos', user.dados.tipo_perfil];
	const tipoProjeto = ['Todos', user.dados.tipo_projeto];
	const tipoEstado = ['Todos', user.dados.estado];

	const getNextSlideIndex = (current) => {
		let nextIndex = current;
		do {
			nextIndex = (nextIndex + 1) % bannersLista.length;
		} while (!(tipoPerfil.includes(bannersLista[nextIndex].cargo) && tipoProjeto.includes(bannersLista[nextIndex].projeto)) && nextIndex !== current);

		return nextIndex;
	};

	useEffect(() => {
		getBanners();
	}, []);

	useEffect(() => {
		let intervalId;

		if (bannersLista.length > 0) {
			intervalId = setInterval(() => {
				setCurrentSlide(prevSlide => getNextSlideIndex(prevSlide));
			}, 4500);
		}

		return () => {
			if (intervalId) clearInterval(intervalId);
		};
	}, [bannersLista.length, tipoPerfil, tipoProjeto]);


	useEffect(() => {
		if (bannersLista.length > 0 && !(tipoPerfil.includes(bannersLista[0].cargo) && tipoProjeto.includes(bannersLista[0].projeto))) {
			setCurrentSlide(getNextSlideIndex(0));
		}
	}, [bannersLista, tipoPerfil, tipoProjeto]);
	return (
		<CarouselContainer>
			{bannersLista.map((banner, index) => (
				<CarouselSlide
					key={index}
					active={(index === currentSlide) && (tipoEstado.includes(banner.estado)) && (tipoPerfil.includes(banner.cargo) && tipoProjeto.includes(banner.projeto))}>
					<Image src={banner.bannerMobile} alt={`Banner ${index + 1}`} active={index === currentSlide} />
				</CarouselSlide>
			))}
		</CarouselContainer>
	);
}

export default Carousel;
